import React, { useEffect, useState } from "react";
import Point from "ol/geom/Point";
import { withStore } from "../../store/Store";
import { crearMarcador } from "./util";
import { fromLonLat } from "ol/proj";
import gisicon from "../../../../assets/img/currentubication.gif";

const ButtonCurrentLocation = withStore(({ storeContext: { map } }) => {
  const [marker] = useState(crearMarcador(map));
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (navigator) {
      if (active) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const placeCoordinate = fromLonLat([
              pos.coords.longitude,
              pos.coords.latitude,
            ]);
            marker.setGeometry(new Point(placeCoordinate));
            map.getView().setCenter(placeCoordinate);
          },
          (err) => {
            console.log(`error location user: ${err}`);
          },
        );
      } else {
        marker.setGeometry(null);
      }
    }
  }, [map, marker, active]);

  return (
    <button
      selected={active}
      className="btn btn-primary btn-sm mr-2"
      title={active ? "Ubicacion activo" : "Ubicacion inactivo"}
      onClick={() => {
        setActive(!active);
      }}
    >
      {active ? (
        <img src={gisicon} width="25px" alt=".." />
      ) : (
        <i className="fa fa-location-arrow" />
      )}
    </button>
  );
});

export default () => {
  return navigator ? (
    <ButtonCurrentLocation googleMaps={window.google.maps} />
  ) : (
    <span>
      <i className="fas fa-times-circle fa-xs text-danger ml-2" />
      Google Maps API no disponible
    </span>
  );
};
